import * as $ from "jquery"
import {Commands} from "../Commands"
import * as MemoryFileWidget from "../../components/spare fields/MemoryFileWidget"
import {AdminMemoryParams, MemoryFolder} from "./Types"
import {CallJs} from "../../lib/types";
import {swfuploader, UploadCallback} from "../../lib/swfuploader/swfuploader";
import {CommandResponse} from "../../lib/commands";
import {getElementByIdOrThrow} from "../../lib/utils"

type UpdateFormParams = {
	notEmptyNotification: JQuery
	uploadDoneNotification: JQuery
	folderSelectorWrapper: JQuery
	topLevelFolderInput: JQuery
	zipFileIdInput: JQuery
	isFolderEmptyInput: JQuery
	btnSubmit: JQuery
	inheritPermissionsInput: JQuery
	permissionsInput: JQuery
}

var updateFormByFolderId = (p: UpdateFormParams, folderId: number) => {
	var inheritPermissions = p.inheritPermissionsInput.is(':checked');
	var isTopLevel = p.topLevelFolderInput.is(':checked');

	var folderSelected = isTopLevel || folderId > 0;
	var uploadComplete = p.zipFileIdInput.val() != '';
	var isFolderEmpty = p.isFolderEmptyInput.val() == '0';

	inheritPermissions ? p.permissionsInput.hide() : p.permissionsInput.show();
	isTopLevel ? p.folderSelectorWrapper.hide() : p.folderSelectorWrapper.show();
	!isTopLevel && !isFolderEmpty ? p.notEmptyNotification.show() : p.notEmptyNotification.hide();
	uploadComplete ? p.uploadDoneNotification.show() : p.uploadDoneNotification.hide();
	p.btnSubmit.prop('disabled', !(folderSelected && isFolderEmpty && uploadComplete));
}

const updateFormKnowingFolderIdWidget = (p: UpdateFormParams) => {
	const folderId = parseInt($('input[name=folderId]').val())
	updateFormByFolderId(p, folderId)
}

const folderSelected = (ajaxPageUrl: string, updateForm: (folderId: number) => void) => (folderId: number) => {
	new Commands(ajaxPageUrl)
		.isFolderEmpty(folderId)
		.then((isEmpty) => {
			;(document.getElementById('isFolderEmpty') as HTMLInputElement).value = isEmpty ? '0' : '1'
			updateForm(folderId)
		})

	return false
}

const onUploadSuccess = <A>(updateForm: () => void) => (file: A, serverData: string) => {
	const processUploadedFile = (result: MemoryUploadBulkFileResult) => {
		;(document.getElementById('zipFileId') as HTMLInputElement).value = result.zipFileId
		updateForm()
	}

	const result = JSON.parse(serverData) as CommandResponse<MemoryUploadBulkFileResult>
	if (result.error)
		alert(result.error.title + "\n\n" + result.error.message)
	else
		processUploadedFile(result.response!)
}

interface BulkUploadParams {
	memoryParams: AdminMemoryParams
	selectedFolder?: MemoryFolder
	ajaxPageUrl: string
	adminFolderSelectorDivId: string
	fileUploaderDivId: string
	uploaderParams: UploaderParamsFromServer
}

interface MemoryUploadBulkFileResult {
	zipFileId: string
}

interface UploaderParamsFromServer {
	// programmer's data
	url: string

	// server config data
	maxSize: string
	swfPath: string
}

interface UploaderParams {
	uploadSuccess: UploadCallback
	known: UploaderParamsFromServer
}

const uploader: CallJs<UploaderParams> = (replace, params) => {
	swfuploader(replace, {
		showCancelButton: false,
		showQueue: true,
		showUploadTotal: true,
		showUploadedTotal: true,
		uploadUrl: params.known.url,
		maxSize: params.known.maxSize,
		fileTypes: '*.zip',
		fileTypesDescription: 'Zip File',
		queueLimit: 1,
		uploadCallback: params.uploadSuccess,
	})
}

export const folderSelector: CallJs<BulkUploadParams> = (replace, params) => {
	var node = document.createElement('div')
	replace(node)

	$(() => {
		const p: UpdateFormParams = {
			notEmptyNotification: $('#nonEmptyFolderWrapper'),
			uploadDoneNotification: $('#uploadDoneNotificationFormItem'),
			folderSelectorWrapper: $('#folderSelectorWrapper'),
			topLevelFolderInput: $('#topLevelFolder'),
			zipFileIdInput: $('#zipFileId'),
			isFolderEmptyInput: $('#isFolderEmpty'),
			btnSubmit: $('#btnSubmit'),
			inheritPermissionsInput: $('#inheritPermissions'),
			permissionsInput: $('#permissionsContainer'),
		}

		const formUpdater = () => (updateFormKnowingFolderIdWidget(p), false)

		$('#selectPermissions').change(formUpdater)
		p.inheritPermissionsInput.change(formUpdater)
		p.permissionsInput.change(formUpdater)
		p.topLevelFolderInput.change(formUpdater)
		$('#specificFolder').change(formUpdater)

		uploader((e: Node) => getElementByIdOrThrow(document, params.fileUploaderDivId).appendChild(e), {
			known: params.uploaderParams,
			uploadSuccess: onUploadSuccess(formUpdater)
		} )

		MemoryFileWidget.renderAdminFolder(
			'folderId',
			params.memoryParams,
			params.selectedFolder,
			getElementByIdOrThrow(document, params.adminFolderSelectorDivId),
			'Select a Folder',
			folderSelected(params.ajaxPageUrl, (id) => updateFormByFolderId(p, id)),
			formUpdater
		)

		updateFormKnowingFolderIdWidget(p)
	})
}



// WEBPACK FOOTER //
// ./src/memory/component/bulk-upload.ts